export default __webpack_public_path__ + "static/media/selfie.31db0f97.JPG";